export enum AssetsControlEnum {
  AssetsList = 'รายการครุภัณฑ์',
  Donate = 'รายการรับบริจาค',
  Transfer = 'รายการรับโอน',
  Discovered = 'รายการสำรวจพบ',
  WaitingTransfer = 'สินทรัพย์รอโอน'
}

export enum AssetsControlEnumMenu {
  AssetsList = 'รายการครุภัณฑ์',
}

export enum AssetsDetailEnum {
  AssetData = 'ข้อมูล',
  RepairMaintenance = 'การซ่อมแซมและบำรุงรักษา',
  History = 'ประวัติการรักษา',
  AssetsHistory = 'ประวัติครุภัณฑ์ (ยืม-คืน)',
  GovernmentVehicle = 'ประวัติการใช้รถราชการ',
  UseOfVehicles = 'การใช้รถ',
  Fuel = 'การใช้น้ำมันเชื้อเพลิง',
  ActInsurance = 'การต่อ พรบ. และจัดทำประกันภัยภาคสมัครใจ',
  Tax = 'ภาษี',
  Battery = 'สถิติการใช้แบตเตอรี่',
  Tire = 'สถิติการใช้ยาง',
  Accident = 'รายงานอุบัติเหตุ',
  Other = 'อื่นๆ',
  CheckAndTax = 'การตรวจสภาพและต่อภาษี',
  AirPollutionAndNoise = 'การตรวจวัดมลพิษทางอากาศและระดับเสียงจากรถราชการ'
}

export enum AssetInspectionEnum {
  WaitingSubmit = 'รายการจัดซื้อจัดจ้าง',
}

export enum AssetInspectionAndControlEnum {
  WaitingSubmit = 'รายการจัดซื้อจัดจ้าง',
  Donate = 'รายการรับบริจาค',
  Transfer = 'รายการรับโอน',
  Discovered = 'รายการสำรวจพบ',
  WaitingTransfer = 'สินทรัพย์รอโอน',
}

export enum StatusInspecProcessEnum {
  WaitingPass = 'รอผ่านรายการ',
  WaitingChecked = 'รอตรวจสอบ',
  WaitingDoing = 'รอดำเนินการ ',
  Reject = 'ไม่อนุมัติ',
  Complete = 'ตรวจรับแล้ว',
  CompleteDepot = 'อนุมัติแล้ว',
  waitingApprove = 'รออนุมัติ',
  WaitingInspecPass = 'รอยืนยันรหัสครุภัณฑ์',
  WaitingReturnTranfer = 'รอรับจ่ายพัสดุ',
  WaitingForLending = 'รอผ่านการจัดสรรครุภัณฑ์',
  WaitingForDirectTransfer = 'รอผอ.อนุมัติจัดสรร',
  Waitingtodelivery = 'รอจ่ายพัสดุ',
  WaitingForTransfer = 'รอรับพัสดุ',
  DuringBorrow = 'อยุ่ระหว่างการยืม',
  DuringReturn = 'รอรับพัสดุคืน',
  ReturnComplete = 'ส่งคืนพัสดุแล้ว',
  WaitingForTransferOut = 'รอโอน ',
  TransferOutComplete = 'ยืนยันการโอน',
  WaitingForTransferOutComplete = 'ยืนยันรหัสครุภัณฑ์',
  WaitingForFixGf = 'รอปรับปรุงรหัส GFMIS',
  WaitingForFixGfComplete = 'รอยินยันรหัส GFMIS',
  CompleteFixGf = 'การเบิกต่อเสร็จสิ้น',

  CANCLE = 'ยกเลิก',
  DRAFT = 'บันทึกแบบร่าง',
  // text จัดซื้อจัดจ้าง/รับบริจาค/รับโอน/สำรวจพบ
  WaitingAssetTeam = 'รอ กค. ตรวจสอบ',
  WaitingConfirm = 'รอยืนยัน',
  ConfirmCode = 'ยืนยันรหัส',
  // text รอโอน
  WaitingAssetDirectorConfirm = 'รอยืนยันการโอน',
  ConfirmTransfer = 'ยืนยันการโอน',


  NotPass = 'ไม่ผ่าน',
}

export enum AssetReturnStatus {
  CANCLE = 0,      // ยกเลิก
  WAITING_APPROVE = 1,      // รออนุมัติการตรวจรับ
  APPROVED = 2,            // ตรวจรับแล้ว
  INSPECTING = 3,          // รอตรวจสอบ
  WAIT_CONFIRM = 4,        // รอยืนยันจำหน่ายออก
  REJECTED = 90,           // ไม่ผ่าน
  CENTER_REJECTED = 91,    // ไม่ผ่าน (ส่วนกลาง)
  NOT_APPROVED = 92,       // ไม่อนุมัติ
  TRANSFERRED = 5,         // รอโอนออก
  TRANSFERRED_OUT = 6      // โอนออกแล้ว
}

export enum AssetsControlStatusEnum {
  Active = 'ใช้งานได้',
  WaitTransfer = 'รอโอน',
  WaittoConfirm = 'รอยืนยันจำหน่ายออก',
  Amortization = 'ตัดจำหน่าย',
  AmortizationOut = 'จำหน่ายออก',
  BorrowProcess = 'อยู่ระหว่างการยืม',
  ReturnProcess = 'ส่งคืน',
  TranFerProcess = 'โอนย้าย',
  Damaged = 'ชำรุด',
  Deteriorated = 'เสื่อมสภาพ',
  Lost = 'สูญหาย',
  Graveyard = 'สุสาน',
}


export enum AssetsEditTypeEnum {
  AssetDetailEdit = 'ครุภัณฑ์',
  LandAndUnit = 'สถานที่ตั้ง/หน่วยงานที่รับผิดชอบ',
  AssetNoEdit = 'หมายเลขครุภัณฑ์',
  AssetCashType = 'ประเภทเงินและการได้มาของสินทรัพย์',
  EditSeller = 'ข้อมูลผู้ขาย/ผู้รับจ้าง/ผู้บริจาค',
  Other = 'รายละเอียดครุภัณฑ์',
  Img = 'รูปภาพ'
}

// แก้ไข Enum ให้ตรงกับตัวเลือกที่แสดงในภาพ
export enum AssetsControlMarketEnum {
  EMarket = '1',
  EBidding = '2',
  PriceSurvey = '3',  // สอบราคา
  Selection = '4',    // คัดเลือก
  SpecificMethod = '5',  // เฉพาะเจาะจง
  Other = '6'         // อื่นๆ
}
